import { type CurrencyCode, getCurrencySymbol } from './currency';
import { truncateDecimal, type FormatDecimal } from './formatting';

export type Amount = [CurrencyCode, string];

export type FormatAmount = (amount: Amount) => string;

export type GetCurrencyCode = (amount: Amount) => CurrencyCode;

export type GetAmountValue = (amount: Amount) => string;

export type AmountToCurrencyString = (formatDecimal: FormatDecimal) => FormatAmount;

export type AmountToValueString = (formatDecimal: FormatDecimal) => FormatAmount;

export const getCurrencyCode: GetCurrencyCode = (amount: Amount): CurrencyCode => amount[0];

export const getAmountCurrencyCode: GetCurrencyCode = getCurrencyCode;

export const getAmountValue: GetAmountValue = (amount: Amount): string => amount[1];

export const amountToCurrencyString: AmountToCurrencyString = (formatDecimal) => (amount: Amount) => 
  `${getCurrencySymbol(amount[0])} ${formatDecimal(truncateDecimal(amount[1]))}`;

export const amountToValueString: AmountToValueString = (formatDecimal) => (amount: Amount) =>
  `${formatDecimal(truncateDecimal(amount[1]))}`;
